//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { crudProfilingScore } from '@/mixins/profiling.js';
import ProfilingTableParameters from '@/components/profiling/ProfilingTableParameters';
export default {
  name: 'ProfilingScoreParams',
  components: {
    ProfilingTableParameters: ProfilingTableParameters
  },
  mixins: [crudProfilingScore],
  data: function data() {
    return {
      tab: 0
    };
  },
  computed: {
    fields: function fields() {
      return [{
        value: 'name',
        text: this.traductor('tablas.name'),
        sortable: true
      }, {
        value: 'weight',
        text: this.traductor('tablas.weight')
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions')
      }];
    },
    fields_sf: function fields_sf() {
      return [{
        value: 'field_type',
        text: this.traductor('tablas.field_type'),
        sortable: true
      }, {
        value: 'weight',
        text: this.traductor('tablas.weight')
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions')
      }];
    },
    fields_st: function fields_st() {
      return [{
        value: 'table_rule',
        text: this.traductor('tablas.table_type'),
        sortable: true
      }, {
        value: 'lower',
        text: this.traductor('tablas.lower')
      }, {
        value: 'upper',
        text: this.traductor('tablas.upper')
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions')
      }];
    },
    texts: function texts() {
      return {
        type: this.traductor('frases.type'),
        field_type: this.traductor('frases.field_type'),
        table_type: this.traductor('frases.table_type')
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    }
  }
};